module.exports = __webpack_public_path__ + "assets/img/A5-3.8dc6452a.jpg";